"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    var _feriados_2023 = [
      {
        date: "2023-01-01",
        name: "Confraternização mundial",
        type: "national",
      },
      {
        date: "2023-02-21",
        name: "Carnaval",
        type: "national",
      },
      {
        date: "2023-04-07",
        name: "Sexta-feira Santa",
        type: "national",
      },
      {
        date: "2023-04-09",
        name: "Páscoa",
        type: "national",
      },
      {
        date: "2023-04-21",
        name: "Tiradentes",
        type: "national",
      },
      {
        date: "2023-05-01",
        name: "Dia do trabalho",
        type: "national",
      },
      {
        date: "2023-06-08",
        name: "Corpus Christi",
        type: "national",
      },
      {
        date: "2023-09-07",
        name: "Independência do Brasil",
        type: "national",
      },
      {
        date: "2023-10-12",
        name: "Nossa Senhora Aparecida",
        type: "national",
      },
      {
        date: "2023-11-02",
        name: "Finados",
        type: "national",
      },
      {
        date: "2023-11-15",
        name: "Proclamação da República",
        type: "national",
      },
      {
        date: "2023-12-25",
        name: "Natal",
        type: "national",
      },
    ];

    $stateProvider.state("main.colorrequest", {
      url: "colorrequest",
      params: {
        expired: false,
      },
      resolve: {
        status: [
          "Status",
          function (Status) {
            return Status.listIds({
              moduleId: window.enumerators.modules.Cores,
            }).$promise;
          },
        ],
        states: [
          "Internal",
          function (Internal) {
            return Internal.states().$promise;
          },
        ],
        managers: [
          "Internal",
          function (Internal) {
            return Internal.ownUsersList({ pageSize: 0, isManager: true }).$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/ColorRequests/colorrequest/views/colorrequest.list.html",
          controller: "colorrequestListCtrl",
          controllerAs: "vm",
        },
      },
    });


    $stateProvider.state("main.colorrequest-edit", {
      url: "colorrequest/:id?chat",
      resolve: {
        model: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            if ($stateParams.id) {
              return ColorRequest.get({ id: $stateParams.id }).$promise;
            }
            return {};
          },
        ],
        workflowApprovals: [
          "$stateParams",
          "WorkflowApproval",
          function ($stateParams, WorkflowApproval) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return WorkflowApproval.list({
              page: 1,
              pageSize: 1000,
              promotionRequestId: id,
            }).$promise;
          },
        ],
        attachmentTypes: [
          "$stateParams",
          "Attachment",
          function ($stateParams, Attachment) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return Attachment.list({
              promotionRequestId: id,
              moduleId: window.enumerators.modules.Cores,
            }).$promise;
          },
        ],
        maxAllowedFileSize: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "MaxAllowedFileSize" })
              .$promise;
          },
        ],
        classificationsTypes: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            return ColorRequest.classificationsTypes().$promise;
          },
        ],
        projectsTypes: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            return ColorRequest.projectsTypes().$promise;
          },
        ],
        customers: [
          "Customer",
          function (Customer) {
            return Customer.listIds().$promise;
          },
        ],
        segments: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.segmentsList().$promise;
          },
        ],
        designers: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.designersList().$promise;
          },
        ],
        reproveReasons: [
          "$stateParams",
          "DisapprovalReason",
          function ($stateParams, DisapprovalReason) {
            return DisapprovalReason.listIds().$promise;
          },
        ],
        salesList: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return ColorRequest.listSales({ colorsRequestId: id }).$promise;
          },
        ],
        holidays: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            return ColorRequest.nationalHolidays({
              year: new Date().getFullYear(),
            }).$promise
              .then(function (response) {
                return response;
              })
              .catch(function (error) {
                console.error("Erro ao buscar feriados:", error);
                return null;
              });
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/ColorRequests/colorrequest/views/colorrequest.edit.html",
          controller: "colorrequestEditCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.colorrequestexternal", {
      url: "colorrequestexternal/:id?",
      resolve: {
        model: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            if ($stateParams.id) {
              return ColorRequest.get({ id: $stateParams.id }).$promise;
            }
            return {};
          },
        ],
        workflowApprovals: [
          "$stateParams",
          "WorkflowApproval",
          function ($stateParams, WorkflowApproval) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return WorkflowApproval.list({
              page: 1,
              pageSize: 1000,
              promotionRequestId: id,
            }).$promise;
          },
        ],
        attachmentTypes: [
          "$stateParams",
          "Attachment",
          function ($stateParams, Attachment) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return Attachment.list({
              promotionRequestId: id,
              moduleId: window.enumerators.modules.Cores,
            }).$promise;
          },
        ],
        maxAllowedFileSize: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "MaxAllowedFileSize" })
              .$promise;
          },
        ],
        classificationsTypes: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            return ColorRequest.classificationsTypes().$promise;
          },
        ],
        projectsTypes: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            return ColorRequest.projectsTypes().$promise;
          },
        ],
        customers: [
          "Customer",
          function (Customer) {
            return Customer.listIds().$promise;
          },
        ],
        segments: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.segmentsList().$promise;
          },
        ],
        reproveReasons: [
          "$stateParams",
          "DisapprovalReason",
          function ($stateParams, DisapprovalReason) {
            return DisapprovalReason.listIds().$promise;
          },
        ],
        salesList: [
          "$stateParams",
          "ColorRequest",
          function ($stateParams, ColorRequest) {
            var id = $stateParams.id ? $stateParams.id : 0;
            return ColorRequest.listSales({ colorsRequestId: id }).$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/ColorRequests/colorrequest/views/colorrequestexternal.edit.html",
          controller: "colorrequestExternalEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
